import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DefaultStateService } from '@formbird/services';

/**
 * NotFoundComponent - Displays a customizable error page
 * 
 * URL Parameters:
 * - title: Custom title for the error page (default: "Page Not Found")
 * - message: Custom error message (default: "Sorry, an error has occured, Requested page not found!")
 * 
 * Examples:
 * - /notFound?title=Access Denied&message=You don't have permission to view this page
 * - /notFound?title=Service Unavailable&message=The service is temporarily unavailable
 */
@Component({
  selector: 'ft-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NotFoundComponent implements OnInit {
  title: string = 'Page Not Found';
  errorMessage: string = 'Sorry, an error has occured, Requested page not found!';

  constructor(
    private defaultStateService: DefaultStateService,
    private route: ActivatedRoute
  ) {
  }

  changeState() {
    this.defaultStateService.changeToDefaultState();
  }

  ngOnInit() {
    // Read URL parameters for title and error message
    this.route.queryParams.subscribe(params => {
      if (params['title']) {
        this.title = params['title'];
      }
      if (params['message']) {
        this.errorMessage = params['message'];
      }
    });
  }
}
